import axios from 'axios';
import MainURL from '../../../MainURL';

const API_BASE = `${MainURL}/api/payments`;

type ApiErrorBody = { ok?: boolean; message?: string };

function getErrorMessage(err: unknown, fallback: string): string {
  if (axios.isAxiosError(err)) {
    const body = err.response?.data as ApiErrorBody | undefined;
    if (typeof body?.message === 'string') return body.message;
  }
  return fallback;
}

export type BillingAuthCheckoutResult = {
  orderId: string;
  customerKey: string;
  clientKey: string;
};

export async function requestBillingAuthCheckout(
  contractId: number,
  source: 'inquiry' | 'contract',
): Promise<BillingAuthCheckoutResult> {
  try {
    const res = await axios.post<{ ok: boolean; message?: string } & Partial<BillingAuthCheckoutResult>>(
      `${API_BASE}/billing-auth/checkout`,
      { contractId, source },
    );
    if (!res.data?.ok || !res.data.orderId) {
      throw new Error(res.data?.message || '정기결제 등록 준비에 실패했습니다.');
    }
    const { orderId, customerKey, clientKey } = res.data;
    return { orderId, customerKey: customerKey!, clientKey: clientKey! };
  } catch (err) {
    throw new Error(getErrorMessage(err, '정기결제 등록 준비에 실패했습니다.'));
  }
}

export async function confirmBillingAuth(params: { orderId: string; customerKey: string; authKey: string }) {
  try {
    const res = await axios.post<{ ok: boolean; message?: string; authChurch?: string | null }>(
      `${API_BASE}/billing-auth/confirm`,
      params,
    );
    if (!res.data?.ok) {
      throw new Error(res.data?.message || '정기결제 등록에 실패했습니다.');
    }
    return { authChurch: res.data.authChurch ?? null };
  } catch (err) {
    throw new Error(getErrorMessage(err, '정기결제 등록에 실패했습니다.'));
  }
}
